import { useEffect, useState } from "react";
import { getActiveSaleTags } from "../helpers/getActiveSaleTags";
import { useAppDispatch, useAppSelector } from "hooks";
import { useWebStoreContext } from "contexts/WebStoreProvider";
import {
	setActiveTags,
	hideHamburgerDot,
	showHamburgerDot,
	selectStickySaleTagState
} from "redux/slices";
import { useEnvContext } from "contexts/EnvProvider";
import { FeaturesFlags } from "helpers";
import { useEliteDealsAccess } from "pages/EliteDeals/hooks/useEliteDealsAccess";
import { useLinks } from "hooks/useLinks";

export const useSetActiveSaleTag = (): void => {
	const dispatch = useAppDispatch();
	const { nowTime, userTracker } = useWebStoreContext();
	const [showed, setShowed] = useState<boolean>();
	const { isFeatureFlagEnabled } = useEnvContext();
	const { saleTags } = useAppSelector(selectStickySaleTagState);
	const activeTags = getActiveSaleTags(saleTags, userTracker, nowTime);
	const isStickyTagEnabled = isFeatureFlagEnabled(FeaturesFlags.STICKY_TAG);
	const canAccessEliteDeals = useEliteDealsAccess();
	const links = useLinks();

	useEffect(() => {
		if (!isStickyTagEnabled) {
			return;
		}
		// @ts-expect-error
		if (typeof nowTime._tzm === "undefined") {
			return;
		}
		if (!activeTags.length) {
			dispatch(hideHamburgerDot());
			return;
		}

		dispatch(setActiveTags(activeTags));
	}, [saleTags, nowTime, isStickyTagEnabled]);

	useEffect(() => {
		if (!isStickyTagEnabled || showed) {
			return;
		}
		for (const tag of activeTags) {
			if (tag.showMegaMenuTag) {
				const section = String(tag.megaMenuTagSection);

				if (section === links.elite_deals.title && !canAccessEliteDeals) {
					return;
				}

				if (
					section === links.club_free_gift.title &&
					!isFeatureFlagEnabled(FeaturesFlags.CLUB_SHOP_FREE_GIFT)
				) {
					return;
				}

				if (
					section === links.pois_bounty.title &&
					!isFeatureFlagEnabled(FeaturesFlags.POIS_BOUNTY)
				) {
					return;
				}

				if (section === links.club_shop.title) {
					if (!isFeatureFlagEnabled(FeaturesFlags.CLUB_SHOP)) {
						return;
					}
					if (!userTracker?.clubId) {
						return;
					}
				}

				if (
					section === links.drip_offer.title &&
					!isFeatureFlagEnabled(FeaturesFlags.DRIP_OFFER)
				) {
					return;
				}
				setShowed(true);
				dispatch(showHamburgerDot());
			}
		}
	}, [showed, activeTags, isStickyTagEnabled]);
};
